module.exports = __webpack_public_path__ + "assets/img/18_1784.90828403.jpg";